import React from 'react';
import DateTimePickerWrapper from '../../../../../../DateTimePickerWrapper/DateTimePickerWrapper';

const EventTimePickers = ({
  startTime,
  endTime,
  openStartPicker,
  openEndPicker,
  handleStartTimeChange,
  handleEndTimeChange,
  setOpenStartPicker,
  setOpenEndPicker,
  size = 'small',
}) => {
  return (
    <>
      <DateTimePickerWrapper
        label="Start Time"
        value={startTime}
        open={openStartPicker}
        onOpen={() => setOpenStartPicker(true)}
        onClose={() => setOpenStartPicker(false)}
        onChange={handleStartTimeChange}
        size={size}
        pickerType="time"
      />
      <DateTimePickerWrapper
        label="End Time"
        value={endTime}
        open={openEndPicker}
        onOpen={() => setOpenEndPicker(true)}
        onClose={() => setOpenEndPicker(false)}
        onChange={handleEndTimeChange}
        size={size}
        pickerType="time"
      />
    </>
  );
};

export default EventTimePickers;
